import classNames from 'classnames';
import { FC, useContext } from 'react';

import { Icon, Link } from '@/shared/ui';

import AuthContext from '@/contexts/Auth/AuthContext';

import './MVSButtonStyles.scss';

interface Props {
  color?: 'white' | 'black';
}

export const MVSButton: FC<Props> = ({ color = 'white' }) => {
  const { storedLinks } = useContext(AuthContext);

  return (
    <Link
      to={storedLinks.externalLink?.mvsWebsite}
      className={classNames('mvs-button', `mvs-button--${color}`)}
      aria-label="Міністерство внутрішніх справ України"
    >
      <Icon color={color} width={130} height={24} className="mvs-button__icon" name="mvs_logo" />
    </Link>
  );
};
